var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSummary = function SvgSummary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    clipPath: "url(#summary_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.25h19.5s1.5 0 1.5 1.5v18s0 1.5-1.5 1.5H2.25s-1.5 0-1.5-1.5v-18s0-1.5 1.5-1.5M5.25.75v3M18.75.75v3M12.75 18h4.5M12.75 10.5h4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.9 15.3-3.15 4.2-2.25-2.25M9.9 7.5l-3.15 4.2L4.5 9.45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "summary_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSummary;